// CVE/KEV 弱點 — mock 種子(智慧看板 18:618 明細表用)。
// 正式資料源=後端爬蟲(單元C);API 到位時替換 dck_helper 資料來源,UI 不動。
export const vulns = [
  { id: 1, cveId: "CVE-2023-20198", cvss: 10, level: "嚴重", affectedCount: 82, isKev: true },
  { id: 2, cveId: "CVE-2024-3400", cvss: 7.2, level: "高", affectedCount: 82, isKev: true },
  { id: 3, cveId: "CVE-2024-21762", cvss: 7.0, level: "高", affectedCount: 82, isKev: false },
  { id: 4, cveId: "CVE-2023-44487", cvss: 6.8, level: "中", affectedCount: 82, isKev: false },
  { id: 5, cveId: "CVE-2024-1086", cvss: 5.4, level: "中", affectedCount: 12, isKev: false },
  { id: 6, cveId: "CVE-2023-5678", cvss: 3.9, level: "低", affectedCount: 4, isKev: false },
];

// 等級彙總(卡片 chips;正式版由後端彙總)
export const vulnSummary = { 嚴重: 18, 高: 55, 中: 18, 低: 41 };
